import React from "react";

function About() {
    return (
        <div className='About'>
            <div className='banner'>
                <div className='aboutMiddle'>
                    {/* <h2>This application was created by Anik Thomas.</h2>

                        <p><h3>Purpose:</h3>
                        The purpose of this application is to list restaurants in Salt Lake City.</p>

                        <p><h3>About this project:</h3>
                            This is my first project making use of the react redux thunk archeticture leveraging the Zomato API</p>

                        <p>Thanks to Steven Blakely that help me out with my API, CSS issues ect.</p>
                        <p>Thanks to Ben Turner as our Instructor and Bob Zirol as Director of Education at V-school,</p>
                        <p>Also Thanks to V-School for the time they have taken presenting these knowledges</p> */}

                </div>
            </div>
        </div>
                )
            }
            
            
export default About;